import { jsx as _jsx } from "react/jsx-runtime";
import { useUserStore } from "@faire/retailer-visitor-shared/stores/domain/UserStore";
import { SubUserNoPermissionsTooltip } from "@faire/retailer-visitor-shared/views/settings/manage-users/NoPermissionsTooltip";
import { useDoActionWhenVisible } from "@faire/web--source/ui/hooks/useDoActionWhenVisible";
import { trackRetailerTeamManagementInsiderMarketingPageTooltipMyTeamCtaClick } from "@faire/web-api--source/events/retailerTeamManagement/click/insiderMarketingPageTooltipMyTeamCta";
import { trackRetailerTeamManagementInsiderMarketingPageInsufficientPermissionsTooltipView } from "@faire/web-api--source/events/retailerTeamManagement/view/insiderMarketingPageInsufficientPermissionsTooltip";
import React from "react";
export var InsiderMarketingPageCTA = function(props) {
    var userCanPlaceOrder = useUserStore([
        "userCanPlaceOrder"
    ]).userCanPlaceOrder;
    var ref = useDoActionWhenVisible(function() {
        trackRetailerTeamManagementInsiderMarketingPageInsufficientPermissionsTooltipView();
    });
    if (!userCanPlaceOrder && !props.hideTooltip) {
        return /*#__PURE__*/ _jsx(SubUserNoPermissionsTooltip, {
            tooltipPosition: props.tooltipPosition,
            innerRef: ref,
            onClick: function() {
                trackRetailerTeamManagementInsiderMarketingPageTooltipMyTeamCtaClick();
            },
            targetNode: props.cta,
            dataTestId: "insider-marketing-page-disabled-cta-tooltip"
        });
    }
    return props.cta;
};
